export default __webpack_public_path__ + "static/media/img_pst_tier_bronze.2446a146.svg";